// extracted by mini-css-extract-plugin
export default {"warningText":"orderAutocomplete_warningText__5h4KM"};